module.exports = __webpack_public_path__ + "img/teeth_circle.612a8b85.png";